import {
  Button,
  Dialog,
  InputLabel,
  DialogNavigation,
  DialogContent,
  DialogCTA,
} from "@sellar-io/components";
import { useState } from "react";
import {
  SupplierRelationshipGetResponseType,
  SupplierRelationshipListResponseType,
} from "@sellar-io/api-v2/types";
import { useSupplierRelationshipUpdate } from "../../../hooks/api/v2/supplierRelationship/useSupplierRelationshipUpdate";
import { EditPaymentTermsRadioSelector } from "./connectionSelector/EditPaymentTermsRadioSelector";

export const AssignPaymentTermsDialog = ({
  active,
  setActive,
  connection,
}: {
  active: boolean;
  setActive: (active: boolean) => void;
  connection?: SupplierRelationshipGetResponseType;
}) => {
  const [paymentDueCalculateFrom, setPaymentDueCalculateFrom] =
    useState<
      SupplierRelationshipListResponseType[number]["paymentDueCalculateFrom"]
    >();

  const [paymentTerms, setPaymentTerms] =
    useState<SupplierRelationshipListResponseType[number]["paymentTerms"]>();

  const [paymentDue, setPaymentDue] = useState<number>();
  const [previousConnection, setPreviousConnection] = useState(connection);
  if (connection !== previousConnection) {
    setPreviousConnection(connection);
    setPaymentTerms(connection?.paymentTerms ?? "proforma");
    setPaymentDueCalculateFrom(
      connection?.paymentDueCalculateFrom ?? undefined,
    );
    setPaymentDue(connection?.paymentDue ?? undefined);
  }

  const updateConnectionMutation = useSupplierRelationshipUpdate(
    connection?.id ? connection.id : 0,
  );

  const loading = updateConnectionMutation.isPending;

  return (
    <Dialog active={active} onDismiss={() => setActive(false)}>
      <DialogNavigation
        leftIcon="CHEVRON_DOWN"
        onClickLeftIcon={() => setActive(false)}
        title="Assign payment terms"
        description="Ensure your customers are seeing the correct payment terms for your business"
      />
      <form
        onSubmit={(e) => {
          e.preventDefault();
          const paymentInfo = {
            paymentTerms: paymentTerms,
            ...(paymentTerms === "credit"
              ? {
                  paymentDue,
                  paymentDueCalculateFrom,
                }
              : { paymentDue: null, paymentDueCalculateFrom: null }),
          };

          updateConnectionMutation.mutate(paymentInfo, {
            onSuccess: () => {
              setActive(false);
            },
          });
        }}
        className="flex flex-col gap-2"
      >
        <DialogContent className="flex flex-col gap-4">
          <InputLabel>Payment terms</InputLabel>
          <EditPaymentTermsRadioSelector
            paymentTerms={paymentTerms}
            setPaymentTerms={(paymentTerms) => setPaymentTerms(paymentTerms)}
            setPaymentDueCalculateFrom={(paymentDueCalculateFrom) =>
              setPaymentDueCalculateFrom(paymentDueCalculateFrom)
            }
            paymentDueCalculateFrom={paymentDueCalculateFrom}
            paymentDue={paymentDue}
            setPaymentDue={(paymentDue) => setPaymentDue(paymentDue)}
            invoiceCreationStage={connection?.Supplier.invoiceCreationStage}
          />
        </DialogContent>
        <DialogCTA>
          <Button type="submit" loading={loading}>
            Confirm
          </Button>
        </DialogCTA>
      </form>
    </Dialog>
  );
};
